export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-960-6caad41bee51443e1d42826cba8d8156.png";